export const PLAYER_GETMEDIA_PATH = '/services/player/v1/getmedia';
export const PLAYER_GETMEDIA_PATH_V3 = '/services/player/v3/getmedia';